import React from 'react'
import { string, node, func, oneOfType } from 'prop-types'
import { css } from '@emotion/react'

const badgeCss = (color) => css`
  display: flex;
  align-items: center;
  color: ${color};
  font-size: 13px;
  font-weight: 500;
  margin-right: 10px;
  height: 20px;
  white-space: nowrap;

  > svg {
    margin-right: 3px;
    fill: ${color};
  }
`

const OnboardingBadge = ({ label, icon: Icon, color }) => (
  <div css={badgeCss(color)}>
    {Icon && <Icon width={20} height={20} />}
    {label}
  </div>
)

OnboardingBadge.propTypes = {
  label: string,
  color: string,
  icon: oneOfType([func, node]),
}

export default OnboardingBadge
